        var modal = document.getElementById("myModal");
        var upperDiv = document.querySelector(".soon-upper-div");
        var span = document.getElementsByClassName("soon-close")[0];

        upperDiv.onclick = function() {
            modal.style.display = "block";
        }

        span.onclick = function() {
            modal.style.display = "none";
        }

        window.onclick = function(event) {
            if (event.target == modal) {
                modal.style.display = "none";
            }
        }

        // Copy functionality
        document.querySelector(".soon-copy-button").addEventListener("click", function() {
            var code = document.getElementById("discount-code").innerText;
            navigator.clipboard.writeText(code).then(function() {
                var copyMessage = document.getElementById("copy-message");
                copyMessage.style.display = "block";
                setTimeout(function() {
                    copyMessage.style.display = "none";
                }, 2000);
            }, function(err) {
                console.error("Could not copy text: ", err);
            });
        });

document.addEventListener("DOMContentLoaded", function () {
    const modals = {
        shipping: document.getElementById("shipping-modal"),
        moneyback: document.getElementById("moneyback-modal"),
        warranty: document.getElementById("warranty-modal"),
        support: document.getElementById("support-modal")
    };

    const triggers = {
        shipping: document.getElementById("shipping-trigger"),
        moneyback: document.getElementById("moneyback-trigger"),
        warranty: document.getElementById("warranty-trigger"),
        support: document.getElementById("support-trigger")
    };

    const closes = {
        shipping: document.getElementById("shipping-close-design-wu"),
        moneyback: document.getElementById("moneyback-close-design-wu"),
        warranty: document.getElementById("warranty-close-design-wu"),
        support: document.getElementById("support-close-design-wu")
    };

    Object.keys(triggers).forEach(key => {
        triggers[key].addEventListener("click", function () {
            modals[key].style.display = "block";
        });

        closes[key].addEventListener("click", function () {
            modals[key].style.display = "none";
        });
    });

    window.addEventListener("click", function (event) {
        Object.keys(modals).forEach(key => {
            if (event.target === modals[key]) {
                modals[key].style.display = "none";
            }
        });
    });
});


